import React, { createContext } from "react";

export const RBACContext = createContext([]);

export function RBACProvider({ children, permissions }) {
  let { Provider } = RBACContext;

  return <Provider value={permissions}>{children}</Provider>;
}
